import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Icons
import { ReactComponent as CloseIcon } from '../../../assets/icons/cross.svg';

import styles from './BurgerMenu.module.scss';
import cn from '../../../utils/cn';
import { useAppContext } from '../../../store/AppContext';

function BurgerMenu({ children, isOpened, onClose }) {
  const [{ activeTab }] = useAppContext();

  useEffect(() => {
    onClose();
  }, [activeTab]);

  return (
    <div className={cn(['d-flex d-col', styles.burger_menu, isOpened ? styles.opened : ''])}>
      <button type="button" onClick={onClose} className={cn([styles.close_btn, 'd-flex a-center j-center'])}>
        <CloseIcon width={28} height={28} />
      </button>

      {children}
    </div>
  );
}

BurgerMenu.propTypes = {
  children: PropTypes.node.isRequired,
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
};

BurgerMenu.defaultProps = {
  isOpened: false,
  onClose: () => {},
};

export default BurgerMenu;
